import { Component, OnInit } from '@angular/core';
import { BannerTypeEnum } from '../../enums/banner-management/banner-type.enum';

@Component({
  selector: 'app-route-algo-admin',
  templateUrl: './route-algo-admin.component.html',
  styleUrls: ['./route-algo-admin.component.css'],
})
export class RouteAlgoAdminComponent implements OnInit {
  selectedTab: number;

  constructor() {}

  ngOnInit(): void {}

  protected readonly bannerType = BannerTypeEnum;
}
